<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" :class="modalClass">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>

          <form v-if="!loading && !successMessage && !errorMessage" @submit.prevent="submitForm">
            <div class="alert alert-info" role="alert">
              <strong>Formato del CSV requerido:</strong>
              <p class="mb-0 mt-2">El archivo debe contener la cabecera <code>CONTRACTID</code>.</p>
            </div>

            <div class="form-group">
              <label for="csvFile">Adjuntar csv con contratos a descargar:</label>
              <input type="file" class="form-control" id="csvFile" accept=".csv" @change="handleFileUpload" required>
              <small v-if="fileSizeError" class="text-danger">El archivo es demasiado grande. Máximo 5MB.</small>
              <small v-if="fileTypeError" class="text-danger">Por favor, selecciona un archivo CSV válido.</small>
              <small v-if="headerError" class="text-danger">Las cabeceras del CSV no coinciden con el formato esperado. Cabecera requerida: <code>CONTRACTID</code></small>
            </div>
            <div class="form-group">
              <label for="email">Introducir el email donde se quiere recibir la descarga solicitada.</label>
              <input type="email" class="form-control" id="email" v-model="email" required>
            </div>
            <button type="submit" class="btn btn-primary" :disabled="fileSizeError || fileTypeError || headerError">Recuperar contratos</button>
          </form>

          <div v-if="successMessage" class="alert alert-success text-center">
            {{ successMessage }}
          </div>

          <div v-if="errorMessage" class="alert alert-danger text-center">
            {{ errorMessage }}
          </div>
        </div>
        <!--<div class="modal-footer" v-if="successMessage || errorMessage">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Cerrar</button>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    modalTitle: String,
    modalClass: String
  },
  data() {
    return {
      email: '',
      csvFile: null,
      fileSizeError: false,
      fileTypeError: false,
      headerError: false,
      loading: false,
      successMessage: '',
      errorMessage: ''
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.fileTypeError = false;
      this.fileSizeError = false;
      this.headerError = false;
      this.csvFile = null;

      if (!file.name.toLowerCase().endsWith('.csv')) {
        this.fileTypeError = true;
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.fileSizeError = true;
        return;
      }

      this.validateCsvHeaders(file);
    },
    validateCsvHeaders(file) {
      const expectedHeaders = ['contractid'];
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const firstLine = text.split(/\r?\n/)[0].replace(/^\uFEFF/, '').trim();
        const separator = firstLine.includes(';') ? ';' : ',';
        const headers = firstLine.split(separator).map(h => h.trim().toLowerCase());
        if (headers.length !== expectedHeaders.length ||
            !expectedHeaders.every((h, i) => headers[i] === h)) {
          this.headerError = true;
        } else {
          this.csvFile = file;
        }
      };
      reader.readAsText(file);
    },
    submitForm() {
      if (this.csvFile && !this.fileSizeError && !this.fileTypeError && !this.headerError) {
        this.loading = true;
        const formData = new FormData();
        formData.append('csv', this.csvFile);

        this.$emit('submitForm', {
          email: this.email,
          formData
        });
      }
    },
    closeModal() {
      this.resetForm();
      this.$emit('close');
    },
    resetForm() {
      this.email = '';
      this.csvFile = null;
      this.fileSizeError = false;
      this.fileTypeError = false;
      this.headerError = false;
      this.loading = false;
      this.successMessage = '';
      this.errorMessage = '';
      const fileInput = document.getElementById('csvFile');
      if (fileInput) {
        fileInput.value = '';
      }
    }
  }
};
</script>
